export var getAreaStyle = function getAreaStyle() {
  return {
    opacity: 0.1
  };
};
export default {
  itemStyle: {
    normal: {
      borderWidth: '1'
    }
  },
  lineStyle: {
    normal: {
      width: '2'
    }
  },
  symbolSize: '5',
  symbol: 'circle',
  showSymbol: false
};